module.exports = __webpack_public_path__ + "f292bdb4efe2f34a08b77e64e254ad21.MP3";